import AdminLayout from '../../layouts/AdminLayout'

export default function UserManagement() {
    return (
        <AdminLayout title='Manage Users'>

        </AdminLayout>
    )
}
